import React from "react";
import Posts from "../components/Posts";

const Home = () => {
    return (
        <div>
            <Posts />
        </div>
    );
};

export default Home;
